import classNames from "classnames/bind";
import { TopLevelNavigation } from "@header";
import { Image, RhLink } from "@/components";
import { dedupeLineBreaks, getLinkData } from "@/core/utils";
import ArrowTailRight from "@/assets/svg/arrow-tail-right-no-padding.svg";
import ExternalArrow from "@/assets/svg/external-arrow.svg";

import styles from './ImageLink.module.scss';
const cx = classNames.bind(styles);

type ImageLinkProps = NonNullable<TopLevelNavigation[number]["linkGroups"]>[number];

export default function ImageLink(props: ImageLinkProps) {
  const { imageLink } = props;
  const { label, subtitle, image, linkType } = imageLink || {};
  const linkData = getLinkData(imageLink);
  const parsedLabel = dedupeLineBreaks(label || "");
  const Icon = linkType?.[0] === 'external' ? ExternalArrow : ArrowTailRight;
  if (!linkData) return null;
  return (
    <RhLink href={linkData.url} target={linkData.target} className={cx("image-link")} data-gtm-section="nav">
      <div className={cx("content-wrapper")}>
        <Image image={image} className={cx("image")} />
        <div className={cx("content")}>
          <div className={cx("copy")}>
            <p className={cx(["title-lc-s", "title"])} dangerouslySetInnerHTML={{ __html: parsedLabel }} />
            { subtitle && <p className={cx(["text-m", "subtitle"])}>{subtitle}</p> }
          </div>
          <Icon className={cx("arrow")} />
        </div>
      </div>
    </RhLink>
  );
}
